module.exports = __webpack_public_path__ + "static/media/microphone_access_chrome.9daa879d.gif";